import { Observable, of } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from "./notifmessage.service";
import { catchError } from "rxjs/operators";
import { Contract } from "../models/contract";
import { Items } from "../models/items";

@Injectable({ providedIn: 'root' })
export class ContractService {

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService
    ) { }

    getContractById(id): Observable<Contract> {
        return this.http.get<Contract>(`${this.configService.config.urlAPI.urlContract}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    deleteContract(id): Observable<Contract> {
        return this.http.delete<Contract>(`${this.configService.config.urlAPI.urlContract}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    deleteContractBySupplierId(id): Observable<Contract> {
        return this.http.delete<Contract>(`${this.configService.config.urlAPI.urlContract}/supplier/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    deleteContractByMerchantId(id): Observable<Contract> {
        return this.http.delete<Contract>(`${this.configService.config.urlAPI.urlContract}/merchant/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    deleteContractByMerchantIdAndSupplierId(merchantId, supplierId): Observable<Contract> {
        return this.http.delete<Contract>(`${this.configService.config.urlAPI.urlContract}/merchant/${merchantId}/supplier/${supplierId}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    updateContract(newContract): Observable<Contract> {
        return this.http.put<Contract>(this.configService.config.urlAPI.urlContract, newContract).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    createContractAPI(newContract): Observable<Contract> {
        return this.http.post<Contract>(this.configService.config.urlAPI.urlContract, newContract).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            return of(null);
        }));
    }

    findByCriteria(criteria): Observable<Items<Contract>> {
        return this.http.get<Items<Contract>>(this.configService.config.urlAPI.urlContract, { params: criteria
          }).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_CONTRACT_API', err);
            let emptyList = new Items<Contract>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }
}